module.exports = __webpack_public_path__ + "static/media/icon-user-disabled.0d13d49f.svg";